import {
  CAPTURED_AADT_SEGMENT_COLORS,
  CAPTURED_AADT_SEGMENT_IDS,
  type CapturedAadtSegmentId,
} from './index';

// Get segment color by index
export function getSegmentColor(index: number): string {
  if (index === 0) return CAPTURED_AADT_SEGMENT_COLORS.SEGMENT_0.color;
  if (index === 1) return CAPTURED_AADT_SEGMENT_COLORS.SEGMENT_1.color;
  return CAPTURED_AADT_SEGMENT_COLORS.SEGMENT_0.color;
}

// Get segment ID by index
export function getSegmentId(index: number): CapturedAadtSegmentId {
  return CAPTURED_AADT_SEGMENT_IDS[index] ?? CAPTURED_AADT_SEGMENT_IDS[0];
}
